import React from 'react' 
import Bredcom from '../../Bredcom/Main' 
import Header from '../../headerone/Main' 
import First from './First' 
// import Brand from './Brand' 
 
function LawSchool() { 
  return ( 
    <> 
        <Header/> 
        <Bredcom title="Home" subtitle="School of Law" /> 
        <First/> 
        {/* <Brand/>  */}
    </> 
  ) 
} 
 
export default LawSchool 